import { render } from "./ModelList.vue?vue&type=template&id=1914ad0e&scoped=true"
import script from "./ModelList.vue?vue&type=script&lang=js"
export * from "./ModelList.vue?vue&type=script&lang=js"

import "./ModelList.vue?vue&type=style&index=0&id=1914ad0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1914ad0e"]])

export default __exports__